export default {
    navigationBarTitleText: intl.get('cooperate.cooperate'),
    navigationBarBackgroundColor: "#DF773C",
};
